module.exports = __webpack_public_path__ + "static/media/union_pay.8b88af3a.png";